import React from 'react';
import { Generic, GenericCollection, JSONLD } from 'react-structured-data';

function JsonLDCategory({ products = [], name, url }) {
  return (
    <JSONLD>
      <Generic
        type="itemList"
        jsonldtype="ItemList"
        schema={{
          name,
          url
        }}
      >
        {products.length > 0 && (
          <GenericCollection type="itemListElement">
            {products.map((product, index) => {
              let name = product.name;
              if (product.fabric) {
                name += ' in ' + product.fabric.name;

                if (product.fabric.collaborator) {
                  name += ' by ' + product.fabric.collaborator.name;
                }
              }

              let images = [];
              if (product.images.length > 0) {
                images.push(product.images[0]?.path);
              }

              const description = product.frame
                ? product.frame.description
                : name;

              return (
                <Generic
                  key={product.id}
                  jsonldtype="ListItem"
                  schema={{ position: index }}
                >
                  <Generic
                    type="item"
                    jsonldtype="Product"
                    schema={{
                      name: name,
                      image: images,
                      description: description,
                      sku: product.sku,
                      mpn: product.id,
                      url: product.url,
                      brand: 'The Inside'
                    }}
                  >
                    <Generic
                      type="offers"
                      jsonldtype="Offer"
                      schema={{
                        url: product.url,
                        priceCurrency: 'USD',
                        price: product.price,
                        priceValidUntil: '2020-11-05',
                        itemCondition: 'https://schema.org/NewCondition',
                        availability: 'https://schema.org/InStock'
                      }}
                    >
                      <Generic
                        type="seller"
                        jsonldtype="Organization"
                        schema={{ name: 'The Inside' }}
                      />
                    </Generic>
                  </Generic>
                </Generic>
              );
            })}
          </GenericCollection>
        )}
      </Generic>
    </JSONLD>
  );
}

export default JsonLDCategory;
